import { Close } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogProps } from "@mui/material";
import { DISQUALIFIED_REWARD_POPUP } from "utils/constants";

import Button from "../button/index";
import { BUTTON_SIZE } from "../button/interface";
import { DisqualifiedRewardDialogProps } from "./interface";
import {
  // ButtonsContainer,
  DialogCloseButton,
  DialogContentWrapper,
  HeadingText,
  MessageText,
  PointsBadge,
  SuggestedSurveyInfo,
  SuggestedSurveyLabel,
  SuggestedSurveyName,
  SuggestedSurveyPoints,
  SuggestedSurveyTime,
  SuggestedSurveyWrapper,
} from "./styled.components";

const DisqualifiedRewardDialog = (props: DisqualifiedRewardDialogProps) => {
  const { show, dismiss, survey, isLoadingSurvey, onStartSurveyClicked } =
    props;

  const handleClose: DialogProps["onClose"] = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    dismiss();
  };

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogContentWrapper>
        <DialogCloseButton onClick={dismiss}>
          <Close />
        </DialogCloseButton>

        <HeadingText>{DISQUALIFIED_REWARD_POPUP.HEADING}</HeadingText>
        <PointsBadge>{DISQUALIFIED_REWARD_POPUP.POINTS_LABEL}</PointsBadge>
        <MessageText>{DISQUALIFIED_REWARD_POPUP.MESSAGE_1}</MessageText>
        <MessageText>{DISQUALIFIED_REWARD_POPUP.MESSAGE_2}</MessageText>

        {isLoadingSurvey && <CircularProgress size={24} />}

        {!isLoadingSurvey && survey && (
          <>
            <SuggestedSurveyLabel>Another survey for you</SuggestedSurveyLabel>
            <SuggestedSurveyWrapper>
              <SuggestedSurveyInfo>
                <SuggestedSurveyName title={survey.surveyNumber}>
                  {survey.surveyNumber}
                </SuggestedSurveyName>
                <SuggestedSurveyPoints>
                  {survey.points} Points
                </SuggestedSurveyPoints>
                {survey.timeToComplete && (
                  <SuggestedSurveyTime>
                    {survey.timeToComplete}
                  </SuggestedSurveyTime>
                )}
              </SuggestedSurveyInfo>
              <Button
                type="button"
                variant="contained"
                margintop="0px"
                bgcolor="#000000"
                textcolor="white"
                buttonsize={BUTTON_SIZE.SMALL}
                onClickHandler={() => onStartSurveyClicked(survey)}
              >
                {DISQUALIFIED_REWARD_POPUP.START_SURVEY_BUTTON_TEXT}
              </Button>
            </SuggestedSurveyWrapper>
          </>
        )}

        {/* <ButtonsContainer>
          <Button
            type="button"
            variant="outlined"
            margintop="0px"
            bordercolor="black"
            buttonsize={1}
            onClickHandler={dismiss}
          >
            {DISQUALIFIED_REWARD_POPUP.CLOSE_BUTTON_TEXT}
          </Button>
        </ButtonsContainer> */}
      </DialogContentWrapper>
    </Dialog>
  );
};

export default DisqualifiedRewardDialog;
